(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel-motion.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel-motion.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const tickets = svs.tickets;
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useRef = _React.useRef,
  useState = _React.useState;
const _tickets$next$compone = tickets.next.components.ticketCarousel.constants,
  DRAG_THRESHOLD_PX = _tickets$next$compone.DRAG_THRESHOLD_PX,
  DRAG_TICKET_FACTOR = _tickets$next$compone.DRAG_TICKET_FACTOR,
  MIN_VELOCITY = _tickets$next$compone.MIN_VELOCITY,
  MOMENTUM_FRAME_MS = _tickets$next$compone.MOMENTUM_FRAME_MS,
  MOMENTUM_FRICTION = _tickets$next$compone.MOMENTUM_FRICTION,
  SNAP_DURATION_MS = _tickets$next$compone.SNAP_DURATION_MS,
  SNAP_THRESHOLD = _tickets$next$compone.SNAP_THRESHOLD;
const _tickets$next$compone2 = tickets.next.components.ticketCarousel.shared,
  clamp = _tickets$next$compone2.clamp,
  easeOutCubic = _tickets$next$compone2.easeOutCubic,
  getGsap = _tickets$next$compone2.getGsap;
const _tickets$next$compone3 = tickets.next.components.ticketCarousel.selection,
  getClosestPositionForTicketNumber = _tickets$next$compone3.getClosestPositionForTicketNumber,
  getNearestPosition = _tickets$next$compone3.getNearestPosition,
  getSafeTicketNumber = _tickets$next$compone3.getSafeTicketNumber,
  getTicketNumberFromPosition = _tickets$next$compone3.getTicketNumberFromPosition,
  getTicketPositionFromNumber = _tickets$next$compone3.getTicketPositionFromNumber;
const useTicketCarouselMotion = _ref => {
  let finishIntro = _ref.finishIntro,
    imageSource = _ref.imageSource,
    _ref$initialSelectedN = _ref.initialSelectedNumber,
    initialSelectedNumber = _ref$initialSelectedN === void 0 ? 1 : _ref$initialSelectedN,
    onPick = _ref.onPick,
    onSelectedNumberChange = _ref.onSelectedNumberChange;
  const initialPosition = getTicketPositionFromNumber(initialSelectedNumber);
  const _useState = useState(initialPosition),
    _useState2 = _slicedToArray(_useState, 2),
    position = _useState2[0],
    setPosition = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDragging = _useState4[0],
    setIsDragging = _useState4[1];
  const positionRef = useRef(initialPosition);
  const positionTweenRef = useRef(null);
  const positionTweenStateRef = useRef({
    value: initialPosition
  });
  const velocityRef = useRef(0);
  const snapFrameRef = useRef(null);
  const momentumFrameRef = useRef(null);
  const suppressClickRef = useRef(false);
  const selectionSyncSuppressedRef = useRef(false);
  const lastAnnouncedNumberRef = useRef(getTicketNumberFromPosition(initialPosition));
  const dragStateRef = useRef({
    active: false,
    canPickOnRelease: false,
    pickNumber: null,
    pointerId: null,
    startX: 0,
    startPosition: 0,
    lastPosition: 0,
    lastTimestamp: 0,
    hasDragged: false
  });
  const selectedNumber = useMemo(() => getTicketNumberFromPosition(position), [position]);
  const announceSelectedNumber = useCallback(ticketNumber => {
    const selectedTicketNumber = getSafeTicketNumber(ticketNumber, lastAnnouncedNumberRef.current);
    if (selectedTicketNumber === lastAnnouncedNumberRef.current) {
      return;
    }
    lastAnnouncedNumberRef.current = selectedTicketNumber;
    onSelectedNumberChange === null || onSelectedNumberChange === void 0 || onSelectedNumberChange(selectedTicketNumber);
  }, [onSelectedNumberChange]);
  const stopSnap = useCallback(() => {
    if (snapFrameRef.current) {
      cancelAnimationFrame(snapFrameRef.current);
      snapFrameRef.current = null;
    }
    if (positionTweenRef.current) {
      positionTweenRef.current.kill();
      positionTweenRef.current = null;
    }
    selectionSyncSuppressedRef.current = false;
  }, []);
  const stopMomentum = useCallback(() => {
    if (momentumFrameRef.current) {
      cancelAnimationFrame(momentumFrameRef.current);
      momentumFrameRef.current = null;
    }
  }, []);
  const setCarouselPosition = useCallback(nextPosition => {
    positionRef.current = nextPosition;
    positionTweenStateRef.current.value = nextPosition;
    if (!selectionSyncSuppressedRef.current) {
      announceSelectedNumber(getTicketNumberFromPosition(nextPosition));
    }
    setPosition(nextPosition);
  }, [announceSelectedNumber]);
  const animateToPosition = useCallback(function (targetPosition) {
    let startPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : positionRef.current;
    let _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$durationMs = _ref2.durationMs,
      durationMs = _ref2$durationMs === void 0 ? SNAP_DURATION_MS : _ref2$durationMs,
      _ref2$suppressInterme = _ref2.suppressIntermediateSelection,
      suppressIntermediateSelection = _ref2$suppressInterme === void 0 ? false : _ref2$suppressInterme;
    stopSnap();
    selectionSyncSuppressedRef.current = suppressIntermediateSelection;
    const delta = targetPosition - startPosition;
    if (Math.abs(delta) <= SNAP_THRESHOLD) {
      selectionSyncSuppressedRef.current = false;
      setCarouselPosition(targetPosition);
      return;
    }
    const gsap = getGsap();
    const tweenState = positionTweenStateRef.current;
    tweenState.value = startPosition;
    if (gsap) {
      positionTweenRef.current = gsap.to(tweenState, {
        value: targetPosition,
        duration: durationMs / 1000,
        ease: 'power3.out',
        overwrite: true,
        onUpdate: () => {
          setCarouselPosition(tweenState.value);
        },
        onComplete: () => {
          positionTweenRef.current = null;
          selectionSyncSuppressedRef.current = false;
          setCarouselPosition(targetPosition);
        }
      });
      return;
    }
    const startTime = performance.now();
    const tick = timestamp => {
      const progress = clamp((timestamp - startTime) / durationMs, 0, 1);
      const nextPosition = startPosition + delta * easeOutCubic(progress);
      setCarouselPosition(nextPosition);
      if (progress < 1) {
        snapFrameRef.current = requestAnimationFrame(tick);
        return;
      }
      snapFrameRef.current = null;
      selectionSyncSuppressedRef.current = false;
      setCarouselPosition(targetPosition);
    };
    snapFrameRef.current = requestAnimationFrame(tick);
  }, [setCarouselPosition, stopSnap]);
  const snapToNearest = useCallback(function () {
    let startPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : positionRef.current;
    animateToPosition(getNearestPosition(startPosition), startPosition);
  }, [animateToPosition]);
  const startMomentum = useCallback(() => {
    stopMomentum();
    stopSnap();
    if (Math.abs(velocityRef.current) < MIN_VELOCITY) {
      velocityRef.current = 0;
      snapToNearest(positionRef.current);
      return;
    }
    const projectedPosition = positionRef.current + velocityRef.current * MOMENTUM_FRAME_MS / (1 - MOMENTUM_FRICTION);
    const targetPosition = getNearestPosition(projectedPosition);
    const distance = Math.abs(targetPosition - positionRef.current);
    const durationMs = clamp(260 + distance * 70, SNAP_DURATION_MS, 820);
    velocityRef.current = 0;
    animateToPosition(targetPosition, positionRef.current, {
      durationMs
    });
  }, [animateToPosition, snapToNearest, stopMomentum, stopSnap]);
  const moveBy = useCallback(direction => {
    stopMomentum();
    stopSnap();
    velocityRef.current = 0;
    suppressClickRef.current = false;
    const targetPosition = getNearestPosition(positionRef.current) + direction;
    announceSelectedNumber(getTicketNumberFromPosition(targetPosition));
    animateToPosition(targetPosition, positionRef.current, {
      suppressIntermediateSelection: true
    });
  }, [animateToPosition, announceSelectedNumber, stopMomentum, stopSnap]);
  const releasePointer = useCallback(function (event) {
    var _event$currentTarget$, _event$currentTarget;
    let cancelMomentum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!dragStateRef.current.active) {
      return;
    }
    if (event !== null && event !== void 0 && event.currentTarget && dragStateRef.current.pointerId !== null && (_event$currentTarget$ = (_event$currentTarget = event.currentTarget).hasPointerCapture) !== null && _event$currentTarget$ !== void 0 && _event$currentTarget$.call(_event$currentTarget, dragStateRef.current.pointerId)) {
      event.currentTarget.releasePointerCapture(dragStateRef.current.pointerId);
    }
    const hadDragged = dragStateRef.current.hasDragged;
    const canPickOnRelease = dragStateRef.current.canPickOnRelease;
    const pickNumber = dragStateRef.current.pickNumber;
    dragStateRef.current = {
      active: false,
      canPickOnRelease: false,
      pickNumber: null,
      pointerId: null,
      startX: 0,
      startPosition: 0,
      lastPosition: 0,
      lastTimestamp: 0,
      hasDragged: false
    };
    setIsDragging(false);
    if (!cancelMomentum && !hadDragged && canPickOnRelease && onPick) {
      suppressClickRef.current = true;
      window.setTimeout(() => {
        suppressClickRef.current = false;
      }, 0);
      onPick(pickNumber || getTicketNumberFromPosition(positionRef.current));
      return;
    }
    if (hadDragged) {
      suppressClickRef.current = true;
      window.setTimeout(() => {
        suppressClickRef.current = false;
      }, 0);
    }
    if (cancelMomentum) {
      velocityRef.current = 0;
      snapToNearest(positionRef.current);
      return;
    }
    startMomentum();
  }, [onPick, snapToNearest, startMomentum]);
  const handlePointerDown = useCallback(event => {
    var _event$target, _event$target$closest, _selectedTicketElemen, _event$currentTarget$2, _event$currentTarget2;
    finishIntro();
    stopMomentum();
    stopSnap();
    velocityRef.current = 0;
    const selectedTicketElement = (_event$target = event.target) === null || _event$target === void 0 || (_event$target$closest = _event$target.closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, '[data-ticket-carousel-selected="true"]');
    const canPickOnRelease = Boolean(selectedTicketElement);
    const pickNumber = canPickOnRelease ? getSafeTicketNumber(selectedTicketElement === null || selectedTicketElement === void 0 || (_selectedTicketElemen = selectedTicketElement.dataset) === null || _selectedTicketElemen === void 0 ? void 0 : _selectedTicketElemen.ticketCarouselNumber, getTicketNumberFromPosition(positionRef.current)) : null;
    dragStateRef.current = {
      active: true,
      canPickOnRelease,
      pickNumber,
      pointerId: event.pointerId,
      startX: event.clientX,
      startPosition: positionRef.current,
      lastPosition: positionRef.current,
      lastTimestamp: event.timeStamp || 0,
      hasDragged: false
    };
    (_event$currentTarget$2 = (_event$currentTarget2 = event.currentTarget).setPointerCapture) === null || _event$currentTarget$2 === void 0 || _event$currentTarget$2.call(_event$currentTarget2, event.pointerId);
    setIsDragging(true);
  }, [finishIntro, stopMomentum, stopSnap]);
  const handlePointerMove = useCallback(event => {
    if (!dragStateRef.current.active) {
      return;
    }
    const deltaX = event.clientX - dragStateRef.current.startX;
    const nextPosition = dragStateRef.current.startPosition - deltaX * DRAG_TICKET_FACTOR;
    const elapsed = Math.max((event.timeStamp || 0) - dragStateRef.current.lastTimestamp, 1);
    const positionDelta = nextPosition - dragStateRef.current.lastPosition;
    dragStateRef.current.hasDragged = dragStateRef.current.hasDragged || Math.abs(deltaX) >= DRAG_THRESHOLD_PX;
    dragStateRef.current.lastPosition = nextPosition;
    dragStateRef.current.lastTimestamp = event.timeStamp || 0;
    velocityRef.current = clamp(positionDelta / elapsed, -0.08, 0.08);
    setCarouselPosition(nextPosition);
  }, [setCarouselPosition]);
  const handlePointerUp = useCallback(event => {
    releasePointer(event);
  }, [releasePointer]);
  const handlePointerCancel = useCallback(event => {
    releasePointer(event, true);
  }, [releasePointer]);
  const handleCenterClick = useCallback((event, ticketNumber) => {
    event.stopPropagation();
    if (suppressClickRef.current) {
      suppressClickRef.current = false;
      return;
    }
    onPick === null || onPick === void 0 || onPick(getSafeTicketNumber(ticketNumber, getTicketNumberFromPosition(positionRef.current)));
  }, [onPick]);
  const handleItemClick = useCallback((event, ticketNumber) => {
    event.stopPropagation();
    if (suppressClickRef.current) {
      suppressClickRef.current = false;
      return;
    }
    const selectedTicketNumber = getSafeTicketNumber(ticketNumber, getTicketNumberFromPosition(positionRef.current));
    const targetPosition = getClosestPositionForTicketNumber({
      position: positionRef.current,
      ticketNumber: selectedTicketNumber
    });
    finishIntro();
    stopMomentum();
    stopSnap();
    velocityRef.current = 0;
    announceSelectedNumber(selectedTicketNumber);
    animateToPosition(targetPosition, positionRef.current, {
      suppressIntermediateSelection: true
    });
  }, [animateToPosition, announceSelectedNumber, finishIntro, stopMomentum, stopSnap]);
  const handleKeyDown = useCallback(event => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      moveBy(-1);
      return;
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      moveBy(1);
      return;
    }
    if ((event.key === 'Enter' || event.key === ' ') && onPick) {
      event.preventDefault();
      onPick(getTicketNumberFromPosition(positionRef.current));
    }
  }, [moveBy, onPick]);
  useEffect(() => {
    positionRef.current = position;
  }, [position]);
  useEffect(() => {
    stopMomentum();
    stopSnap();
    velocityRef.current = 0;
    lastAnnouncedNumberRef.current = null;
    setCarouselPosition(getTicketPositionFromNumber(initialSelectedNumber));
  }, [imageSource, initialSelectedNumber, setCarouselPosition, stopMomentum, stopSnap]);
  useEffect(() => () => {
    stopMomentum();
    stopSnap();
  }, [stopMomentum, stopSnap]);
  return {
    handleCenterClick,
    handleItemClick,
    handleKeyDown,
    handlePointerCancel,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    isDragging,
    moveBy,
    position,
    selectedNumber
  };
};
setGlobal('svs.tickets.next.components.ticketCarousel.useTicketCarouselMotion', useTicketCarouselMotion);

 })(window);